export function slideToId(id) {
  const el = document.getElementById(id)
  el?.scrollIntoView({ behavior: 'smooth' })
}
